import GeneralView from '~/generalView';
import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import profile_template from '~/templates/changelog.handlebars';

/**
 * Category View (show category title and a report ranking of a report)
 * @constructor
 * @type {*}
 */
var ChangelogView = GeneralView.View.extend({
    tagName: "div",
    className: 'Changelog',
    news: [],
	
    initialize: function () {
		
	},
	
	events: {
		
	},
	
	render: function () {
		this.attachEvents();
		return this;
	},
	
	attachEvents: function() {
		var handlebarsTemplate = Handlebars.template(profile_template);
		this.$el.html(handlebarsTemplate());
	},
});
/**
 *
 * Module profileView
 * @module views/profileView
 * @returns ParseService
 */
export default ChangelogView;
